<div class="container">
  <app-product-list [fixAnyVerdict]="true" [entryWidget]="productWidget"></app-product-list>
</div>

<ng-template #productWidget let-entry="entry" let-query="query">
  <app-ma-product-widget [entry]="entry" [query]="query"></app-ma-product-widget>
</ng-template>
